import React from 'react';

import { Radio } from '@headlessui/react';

import Icon from 'flow/components/ui-components/Icon';

import SettingRow from './SettingRow';

interface Props {
    deviceId: string;
    label: string;
    selected: boolean;
}

/* One device in a picker list; the caller wraps the rows in a `RadioGroup`,
   which owns the value and the change. The radio is only the label text, but
   its stretched pseudo-element covers the row that `relative` anchors, so a
   click anywhere in the row picks the device. The radio tells a screen reader
   which device is the current one; the check icon in `cta` is only the
   visual. */
const DevicePickerRow = ({ deviceId, label, selected }: Props) => (
    <SettingRow
        className="relative"
        cta={selected ? <Icon iconKey="done" /> : null}
    >
        <Radio value={deviceId} className="stretched-control cursor-pointer">
            {label}
        </Radio>
    </SettingRow>
);

export default DevicePickerRow;
